import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import ReactDataSheet from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';
import { Button } from '@material-ui/core';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function InsertColumn({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'first');
    const [data, setData] = useState(action.fields.column?.value ? action.fields.column.value : [[''], ['']]);
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.INSERT-COLUMN.';
    useEffect(() => {
        // Assign initial values
        if (!action.fields.tab) { action.fields.tab = { value: 'first' }; }
    }, []);
    // Handle tab change
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.tab = { value };
        setTab(value);
    }
    // const displayData = (x, y) => {
    //     return data?.[y]?.[x];
    // };
    // // Handle table change
    // const onChange = (changes) => {
    //     const newData = [...data];
    //     for (const change of changes) {
    //         if (!newData[change.y]) {
    //             newData[change.y] = [];
    //         }
    //         newData[change.y][change.x] = change.value;
    //     }
    //     action.fields.column = { value: newData };
    //     setData(newData);
    // };
    // Handle cell value changes
    const onCellsChanged = changes => {
        const grid = data.map(row => [...row]);
        changes.forEach(({ cell, row, col, value }) => {
            grid[row][col] = value;
        });
        action.fields.table = { value: grid };
        // Update state
        setData(grid);
    }
    // Handle removing row
    const handleAddRow = (e) => {
        let newRow = [''];
        data.push(newRow);
        // Add new row
        setData([...data]);
    }
    // Handle removing row
    const handleRemoveRow = (e) => {
        // Remove row
        if (data.length > 1) {
            data.pop();
            setData([...data]);
        }
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'SOURCE')}
                <VariablePicker action={action} inputName="assignSource" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'INDEXES')}
            </div>
            <div className="condition-tabs">
                <button className={tab === 'first' ? 'condition-active' : ''} value="first" onClick={handleClick}>
                    {t(label + 'FIRST')}
                </button>
                <button className={tab === 'last' ? 'condition-active' : ''} value="last" onClick={handleClick}>
                    {t(label + 'LAST')}
                </button>
                <button className={tab === 'specific' ? 'condition-active' : ''} value="specific" onClick={handleClick}>
                    {t(label + 'SPECIFIC')}
                </button>
            </div>{tab === 'specific' &&
                <div className="form-element">
                    <TextInput action={action} inputName="index" variables={variables} setOpenVariable={setOpenVariable} />
                </div>}
            <div className="form-element">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {t(label + 'ROW')}
                    <div>
                        <Button onClick={handleAddRow}><AddCircleOutline /></Button>
                        <Button onClick={handleRemoveRow}><RemoveCircleOutline /></Button>
                    </div>
                </div>
                <ReactDataSheet
                    data={data}
                    valueRenderer={cell => cell}
                    onCellsChanged={onCellsChanged}
                />
            </div>
        </div>
    );
}
export default InsertColumn;